import { CloudCustomerOrderAddress } from "@omni/types/api/customer/cloud/orderAddress.model";
import { ComponentsCustomerAddress } from "@omni/types/components/customer/address.model";
import { ModelMapper } from "@omni/types/utils/modelMapper";

const fromCloudCustomerOrder: ModelMapper<
    CloudCustomerOrderAddress,
    ComponentsCustomerAddress
> = (model) => {
    return {
        addressing: model.addressing,
        city: model.city,
        box: model.box,
        street: model.street,
        zipCode: model.zipCode,
        number: model.number,
        country: model.countryName,
        firstName: model.firstName,
        lastName: model.lastName
    };
};

export const ComponentsAddressMapper = {
    fromCloudCustomerOrder
};
